<template>
  <v-app
    :style="{ fontFamily: fontFamily ? fontFamily : 'Ubuntu, sans-serif' }"
  >
    <!--start main content-->
    <v-main class="background">
      <router-view />
    </v-main>
    <!--end main content-->

    <v-footer padless>
      <v-card class="flex" flat tile>
        <v-card-title style="background-color: #F5F5F5;">
          <span
            class="text-muted font-size-md"
            style="font-size: 12px !important;"
          >
            {{ $t("generic.lang_footer_made_with") }}
            <a
              href="https://www.3pos.de"
              style="color: #f84611; cursor: pointer; text-decoration: none;"
            >
              3POS
            </a>
          </span>

          <v-spacer></v-spacer>

          <!-- <v-btn
            @click="changeLocale('en')"
            v-if="this.language === 'de'"
            class="mx-4"
            text
          >
            <flag style="font-size: 30px" iso="gb" />
          </v-btn>

          <v-btn
            @click="changeLocale('de')"
            v-if="this.language === 'en'"
            class="mx-4"
            text
          >
            <flag style="font-size: 30px" iso="de" />
          </v-btn> -->

          <v-speed-dial v-model="fab">
            <template v-slot:activator>
              <v-btn
                v-if="$i18n.locale === 'de'"
                v-model="fab"
                fab
                icon
                dark
                small
                ripple
                class="ma-0"
                right
                depressed
                elevation="0"
              >
                <v-avatar size="30">
                  <flag style="font-size: 60px" iso="de" />
                </v-avatar>
              </v-btn>
              <v-btn
                v-if="$i18n.locale === 'en'"
                v-model="fab"
                fab
                icon
                dark
                small
                ripple
                class="ma-0"
                right
                depressed
                elevation="0"
              >
                <v-avatar size="30">
                  <flag style="font-size: 60px" iso="gb" />
                </v-avatar>
              </v-btn>
              <v-btn
                v-if="$i18n.locale === 'fr'"
                v-model="fab"
                fab
                icon
                dark
                small
                ripple
                class="ma-0"
                right
                depressed
                elevation="0"
              >
                <v-avatar size="30" class="mx-auto">
                  <flag style="font-size: 60px" iso="fr" />
                </v-avatar>
              </v-btn>
            </template>

            <v-btn
              v-if="$i18n.locale !== 'de'"
              @click="changeLocale('de')"
              fab
              icon
              dark
              small
              ripple
              class="ma-0"
              right
              depressed
              elevation="0"
            >
              <v-avatar size="30">
                <flag style="font-size: 60px" iso="de" />
              </v-avatar>
            </v-btn>
            <v-btn
              v-if="$i18n.locale !== 'en'"
              @click="changeLocale('en')"
              fab
              icon
              dark
              small
              ripple
              class="ma-0"
              right
              depressed
              elevation="0"
            >
              <v-avatar size="30">
                <flag style="font-size: 60px" iso="gb" />
              </v-avatar>
            </v-btn>
            <v-btn
              v-if="$i18n.locale !== 'fr'"
              @click="changeLocale('fr')"
              fab
              icon
              dark
              small
              ripple
              class="ma-0"
              right
              depressed
              elevation="0"
            >
              <v-avatar size="30">
                <flag style="font-size: 60px" iso="fr" />
              </v-avatar>
            </v-btn>
          </v-speed-dial>
        </v-card-title>

        <v-card-text
          class="py-3 text-center"
          style="background-color: #1E1E1E;"
        >
          <router-link
            to="privacy"
            style="text-decoration: none;"
            class="blue--text"
          >
            {{ $t("generic.lang_privacy") }}
          </router-link>
          <router-link
            to="conditions"
            style="text-decoration: none;"
            class="blue--text mx-5"
          >
            {{ $t("generic.lang_conditions") }}
          </router-link>
          <router-link
            to="imprints"
            style="text-decoration: none;"
            class="blue--text"
          >
            {{ $t("generic.lang_imprint") }}
          </router-link>
        </v-card-text>
      </v-card>
    </v-footer>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import { updateCurrencyFilter } from "@/plugins/currency";

export default {
  name: "App",

  data() {
    return {
      fab: false,
    };
  },

  computed: {
    ...mapGetters({
      defaultLang: "config/defaultLang",
      countryIso: "config/countryIso",
      fontFamily: "config/fontFamily",
    }),
  },
  watch: {
    defaultLang(val) {
      if (!localStorage.getItem("lang")) {
        this.changeLocale(val);
        window.store.dispatch("config/loadConfig");
      }
    },
    countryIso(val) {
      updateCurrencyFilter(this, val);
    },
  },

  methods: {
    changeLocale(locale) {
      this.$i18n.locale = locale;
      this.$axios.defaults.headers.common["language"] = locale;
      this.$vuetify.lang.current = locale;
      localStorage.setItem("lang", locale);
      this.$forceUpdate();
    },
  },

  mounted() {
    // window.store.dispatch("config/loadConfig");
    updateCurrencyFilter(this, this.countryIso);
  },
};
</script>
